import React from 'react';
import {motion} from 'framer-motion'
import './footer.css'

function Footer() {
  return (
    <motion.div
          initial={{opacity:0}}
          animate={{opacity:1}}
          transition={{duration:0.5, delay:0.5}}
          className="footer">
            <h4>Design and Created By <span style={{color:"gold"}}>Foma</span>Cept</h4>
            <p>&copy;FOMOVIE</p>
            <h6 style={{background:'#01b4e4'}}>TMDB API</h6>
    </motion.div>
  )
}

export default Footer